import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Lenis from 'lenis';

// GSAP
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from "gsap/SplitText";
import { horizontalLoop } from "./gsapHorizontalLoop";

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

// Components
import headingModule from './heading.js';
import youtubeBackgroundModule from './youtubeBackground.js';
import videoBackgroundModule from './videoBackground.js';

// Modules
headingModule();
youtubeBackgroundModule();
videoBackgroundModule();

// Global
window.Alpine = Alpine;
Alpine.plugin(collapse);

// GSAP Configuration
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.SplitText = SplitText;
window.gsapHorizontalLoop = horizontalLoop;

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

// Inits
Alpine.start();

// Lenis
const lenis = new Lenis({
    autoRaf: true,
    duration: 1.2,
    anchors: true,
    prevent: (node) => node.classList?.contains('facets-popup-modal')
});

lenis.on('scroll', ScrollTrigger.update);

window.lenis = lenis;